// Keeps window.customerHasFreeSwatch in sync with the live cart after AJAX cart
// changes (add/update/change — anywhere on the site, since the mini-cart is global),
// and refreshes every already-rendered swatch price on the page to match — no reload.
// Initial page-load state comes from components/global/snippet.theme-scripts.liquid.
//
// The up-to-date value is read off the <cart-content> element itself rather than the
// raw cart JSON: components/mini-cart/snippet.cart-content.liquid and
// section.main-cart.liquid stamp a data-customer-has-free-swatch attribute onto
// <cart-content>, computed with the same reliable product-tag check used by the
// PLP/PDP price snippets, and components/cart/cart-content.js already morphs that
// element (mini-cart is present on every page) into the DOM on every cart change —
// so by the time "cart:updated" fires (dispatched right after "updateCart", which is
// what cart-content.js listens on to morph), the attribute is guaranteed current.

// Applies the current window.customerHasFreeSwatch to a single price-snippet. Exposed as
// window.syncSwatchPriceSnippet so components/main-collection/product-grouping.js can call it
// right after swapping in a price-snippet it captured earlier (color-swatch preview on a
// grouped PLP card) — that captured markup can be stale relative to the live cart by the time
// it's reused, since it was snapshotted once rather than re-fetched.
function syncSwatchPriceSnippet(priceSnippet) {
  if (!priceSnippet || priceSnippet.dataset.swatchProduct !== "true") return;

  const rawPrice = parseFloat(priceSnippet.dataset.rawPrice);

  if (Number.isNaN(rawPrice)) return;

  const price = window.customerHasFreeSwatch ? rawPrice : 0;
  const compareAtPrice = window.customerHasFreeSwatch ? 0 : rawPrice;

  priceSnippet.setAttribute("price", String(price));
  priceSnippet.setAttribute("compare-at-price", String(compareAtPrice));

  priceSnippet.dataset.basePrice = String(price);
  priceSnippet.dataset.baseCompareAtPrice = String(compareAtPrice);
  priceSnippet.dataset.freePrice = String(!window.customerHasFreeSwatch);
}

window.syncSwatchPriceSnippet = syncSwatchPriceSnippet;

function refreshPriceSnippets() {
  document.querySelectorAll('price-snippet[data-swatch-product="true"]').forEach(syncSwatchPriceSnippet);
}

function refreshAddToCartButtons() {
  document.querySelectorAll('[data-product-form-atc][data-swatch-product="true"]').forEach((button) => {
    const rawPrice = parseFloat(button.dataset.rawPrice);

    button.dataset.freePrice = String(!window.customerHasFreeSwatch);

    if (Number.isNaN(rawPrice) || button.disabled) return;

    const content = button.querySelector(".product-form__atc-content");

    if (!content) return;

    const currency = document.querySelector("[data-main-product-price]")?.getAttribute("currency") || "USD";
    const displayPrice = window.customerHasFreeSwatch ? rawPrice : 0;
    const formattedPrice = window.formatMoney(displayPrice / 100, true, currency);
    const addToCartLabel = button.closest("product-form")?.dataset.localeAdd || "Add to cart";

    content.textContent = `${addToCartLabel} - ${formattedPrice}`;
  });
}

document.addEventListener("cart:updated", () => {
  const cartContentEl = document.querySelector("cart-content[data-customer-has-free-swatch]");

  if (!cartContentEl) return;

  const hasFreeSwatch = cartContentEl.dataset.customerHasFreeSwatch === "true";

  if (hasFreeSwatch === window.customerHasFreeSwatch) return;

  window.customerHasFreeSwatch = hasFreeSwatch;

  refreshPriceSnippets();
  refreshAddToCartButtons();
});
